module.exports = __webpack_public_path__ + "static/img/2023年历-8.5edefb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2023年历-8.jpg
// module id = 8/Hy
// module chunks = 3